module.exports = __webpack_public_path__ + "img/logo-tuti.ab910373.png";